import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spinner } from "../../core/components/Spinner";
import "./HomePortal.css";
import "./Portal.css";
import "./HomeEncuesta.css";
import { usePortal } from "./hook/usePortalState";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { TestEncuesta } from "../../modules/Talentohumano/ConfigTest/prueba/TestEncuesta";
import { BasicButton } from "../../modules/theme/Component/BasicButton";
import { toast } from "react-toastify";
import { configPortal } from "../../configPortal";
import { NotFound } from "../../modules/theme/NotFound";
import { _Proof, _ProofAccounts, _single, _Test } from "../../core/services/dataBean/EntityCatalog";
import { Alert } from "../../modules/theme/Component/Alert";


export const HomeEncuesta = () => {
    const { token }: any = useParams();
    const { viewMenu, setIsMovil, setViewMenu } = usePortal();
    const _proof = useDataBean(_Proof);
    const _proofAccounts = useDataBean(_ProofAccounts);
    const [hashCode, setHashCode] = useState<any>();
    const [completo, setCompleto] = useState<boolean>(false);
    const [proof, setProof] = useState<any>({});
    const _test = useDataBean(_Test);
    const navigate = useNavigate();

    const response = useRef<any>();

    const enviarEncuesta = () => {

        console.log(response.current);
        
        let b = {...proof};
        b.State = 3;
        b.AnswerDate = _single.getCurrenDate();
        _proofAccounts.updateCustonBean(b);

        _test.instance.setResponseProofTest(proof.IDTest, proof.IDAccount, response.current).then(
            (resp: any) => {
                toast.success("Respuestas enviadas, Muchas gracias por su participación");
                _single.printOut(resp);
                navigate("/");

            }
        ).catch((e) => { toast.error("Hubo un error, Intentalo mas Tarde") })
    }


    useEffect(() => {
        const handleResize = () => {
            const mobileView = window.innerWidth <= 990.40;
            _single.setWindowSize(window.innerWidth, window.innerHeight);
            setIsMovil(mobileView);
            if (window.innerWidth >= 770) {
                setViewMenu(true);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);

    }, []);


    useEffect(() => {
        if (token) {
            setHashCode(atob(token));
        }
    }, [token])
    useEffect(() => {
        if (hashCode > 0) {
            
            _proofAccounts.instance.getProofAccountsCatalogPorPropiedadesRender({ HashCode: parseInt(hashCode) }).then(
                (resp: any) => {
                    console.log(resp);

                    if (resp)
                        if (resp.length > 0) {
                            setProof(resp[0].DataBeanProperties);
                        }
                }
            )
        }
    }, [hashCode])

    const footerInfo = configPortal.FOOTER_INFO ?? "Trv, Tv. 69b Bis #73a-40, Bogotá, Cundinamarca";
    const imgLogin = configPortal.IMG_LOGIN ?? "";
    const logo = configPortal.IMG_SOURCE ?? _single.getIMGLogo();

    return (
        <>
            <Spinner />
            <div className="container-fluid d-flex justify-content-center flex-column min-vh-100 p-0">
                <header className="portal-header">
                    <img
                        src="./assets/images/core/govco.png"
                        alt="gov.co"
                        style={{ maxHeight: "60px", height: "auto", width: "auto", objectFit: "contain" }}
                    />

                </header>
                <div className="d-flex justify-content-center align-items-center flex-grow-1"
                    style={{
                        backgroundImage: imgLogin
                            ? `url('./assets/images/customizables/${imgLogin}')`
                            : "linear-gradient(-45deg, #036 50%, #069)",
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }}>

                    {proof.HashCode ?
                        <div className="card-encuesta shadow p-4">
                            <div className="row">
                                <div className="col-md-12 d-flex align-items-center justify-content-between">
                                    <h5 className="mb-0"><strong>Encuesta de Satisfacción</strong></h5>
                                    <img
                                        src={`./assets/images/customizables/${logo ?? "logo-amc-negro.png"}`}
                                        alt="Logo Banco"
                                        className="logo-img-encuesta"
                                        style={{ maxHeight: "100px", objectFit: "contain" }}
                                    />
                                </div>
                                <hr />
                                <div className="col-md-12">
                                    {proof.State == 3 &&
                                        <Alert clase="primary">
                                            <strong>Gracias</strong> <br />la encuesta ya se encuentra finalizada.
                                            <br /><br /><a href="/" className="link">Inicio</a>
                                        </Alert>
                                    }
                                    {(proof.IDTest && proof.State==1) &&
                                        <>
                                            <TestEncuesta hideTittle idTest={proof.IDTest} exportResult={(e) => { response.current = e }} isComplete={setCompleto} />
                                            <BasicButton icon="ri-mail-send-line" disable={!completo} useMargin eventClick={enviarEncuesta}>Enviar</BasicButton>
                                            {/* {completo === true &&
                                            <p>Respuestas completas</p>
                                            } */}
                                        </>
                                    }
                                </div>
                                {/* <div className="col-md-12">
                                    <PrintJson json={hashCode} />
                                    <PrintJson json={proof} />
                                </div> */}
                            </div>
                        </div>
                        :
                        <NotFound />
                    }
                </div>

                <footer className="w-100 d-flex align-items-center justify-content-center text-center mt-auto"
                    style={{ maxHeight: "50px", backgroundColor: "#025dc3", height: "50px" }}>
                    <p style={{ color: "white", fontSize: "0.9rem", margin: 0 }}>
                        {footerInfo}
                    </p>
                </footer>
            </div>
        </>

    );
};
